import FormField from './FormField'
import FormFieldContainer from './FormFieldContainer'
import * as VARIANTS from './variants'
import * as NAMES from './names'
import TYPES from './types'

Object.keys(VARIANTS).forEach(v => {
  FormField[v] = FormFieldContainer(VARIANTS[v])(FormField)
})

FormField.NAMES = NAMES
FormField.TYPES = TYPES

export default FormField

export { NAMES, TYPES }
